<template>
    <!-- {{ item }} -->
    <div class="p-3 rounded-[10px] border-[1px] border-[#CCCCCC] bg-white cursor-pointer">
        <div class="flex items-start !justify-between !w-full">
            <div class="flex justify-start items-center gap-1">
                <p class="mobile:text-[14px] laptop:text-[16px] font-roboto m-0 text-[#9C9BBF]">{{
                    $helper.formatDateTime(item.sale_date) }}</p>
            </div>
            <div class="flex items-start gap-3">
                <h6 class="flex items-center gap-2 m-0 font-roboto font-medium text-[14px] text-[#EA8A8A]">Status
                    <img :src="getStatusImage(item.status)" alt="status-icon" class="w-4 h-4 object-cover">
                </h6>
                <img :src="item.partner_company_logo" alt="status-icon" class="w-10 h-8 object-contain">
            </div>
        </div>
        <div class="mobile:mb-1 laptop-m-0">
            <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">Plan
                Name:</label>
            <p class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333]">{{ item.plan_name }} <span
                    class="text-[14px] font-roboto font-normal text-[#999999]">({{ item.trade_name
                    }})</span></p>
        </div>
        <div class="flex mobile:flex-col tablet:flex-row flex-wrap mobile:gap-1 laptop:gap-4">
            <div class="flex gap-2">
                <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">ID:
                </label>
                <p class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-20">{{
                    $helper.isEmpty(item.id) ? '-' :
                    item.id }}</p>
            </div>
            <div class="flex gap-2 ">
                <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">SRO
                    Number: </label>
                <p class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-20">{{
                    $helper.isEmpty(item.sro_number) ? '-'
                        :
                        item.sro_number }}</p>
            </div>
            <div class="flex gap-2">
                <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">Consumer
                    Name: </label>
                <p class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-32">{{
                    getShortPlanName(item.consumer_name)
                    }}
                    <span class="opacity-0 group-hover:!opacity-100 transition-opacity duration-300 max-w-[250px]
             absolute left-0 top-full mt-1 z-10 bg-white text-black text-sm
             px-2 py-1 rounded shadow-xl border border-gray-300">
                        {{ item.consumer_name }}
                    </span>
                </p>
            </div>
            <div class="flex gap-2">
                <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">Plan
                    Amount: </label>
                <p class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-20">${{
                    item.total_amount }}/mo</p>
            </div>
            <div class="flex gap-2">
                <label class="m-0 font-roboto font-medium mobile:text-[15px] laptop:text-[16px] text-[#EA8A8A]">Approved
                    Date: </label>
                <p v-if="item.approved_at.length > 0" class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-20">{{
                    $helper.formatDateTime(item.approved_at) }}</p>
                <p v-else class="mobile:text-[15px] laptop:text-[16px] font-roboto m-0 text-[#333333] min-w-20">-</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        getShortPlanName(name) {
            if (this.$helper.isEmpty(name)) return '-';
            return name.length > 30 ? name.substring(0, 30) + '...' : name;
        },
        getStatusImage(status) {
            switch (status) {
                case 'pending':
                    return require('@/assets/images/pending-status.png');
                case 'approved':
                    return require('@/assets/images/circle-check.png');
                case 'rejected':
                    return require('@/assets/images/reject-status.png');
                default:
                    return require('@/assets/images/pending-status.png');
            }
        }
    }
}
</script>